export var ProductCardTab;
(function(ProductCardTab) {
    ProductCardTab[ProductCardTab['SUMMARY'] = 0] = 'SUMMARY';
    ProductCardTab[ProductCardTab['MORE_INFO'] = 1] = 'MORE_INFO';
})(ProductCardTab || (ProductCardTab = {}));

//# sourceMappingURL=types.js.map